export const FETCH_LOGIN_REQUEST = 'FETCH_LOGIN_REQUEST'
export const FETCH_LOGIN_SUCCESS = 'FETCH_LOGIN_SUCCESS'
export const FETCH_LOGIN_FAILED = 'FETCH_LOGIN_FAILED'



// WEBPACK FOOTER //
// ./src/modules/Auth/const.js